import React from "react";

const CareerButton = React.forwardRef(({ children, onClick }, ref) => {
  return (
    <button
      ref={ref}
      onClick={onClick}
      className="text-sm hover:text-primary hover:font-bold"
    >
      {children}
    </button>
  );
});

CareerButton.displayName = "CareerButton";

export default CareerButton;
